import { createMessageName } from '@formkit/validation';
import { sentence, date, list } from '../formatters.mjs';

// packages/i18n/src/locales/de.ts
var add = "Hinzufügen";
var remove = "Entfernen";
var removeAll = "Alles entfernen";
var incomplete = "Entschuldigung, nicht alle Felder wurden korrekt ausgefüllt.";
var submit = "Senden";
var noFiles = "Keine Datei ausgewählt";
var moveUp = "Gehe nach oben";
var moveDown = "Gehen Sie nach unten";
var isLoading = "Wird geladen...";
var loadMore = "Mehr laden";
var next = "Weiter";
var prev = "Zurück";
var addAllValues = "Alle Werte hinzufügen";
var addSelectedValues = "Ausgewählte Werte hinzufügen";
var removeAllValues = "Alle Werte entfernen";
var removeSelectedValues = "Ausgewählte Werte entfernen";
var chooseDate = "Datum wählen";
var changeDate = "Datum ändern";
var close = "Schliessen";
var open = "Offen";
var accepted = function({
  name
}) {
  return `Bitte ${name} akzeptieren.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} muss nach dem ${date(args[0])} liegen.`;
  }
  return `${sentence(name)} muss in der Zukunft liegen.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} darf nur Buchstaben enthalten.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} darf nur Buchstaben und Zahlen enthalten.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} dürfen nur Buchstaben und Leerzeichen enthalten.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} muss alphabetische Zeichen enthalten.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} muss Buchstaben oder Zahlen enthalten.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} muss Buchstaben oder Leerzeichen enthalten.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} muss ein Symbol enthalten.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} muss Großbuchstaben enthalten.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} muss Kleinbuchstaben enthalten.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} muss Zahlen enthalten.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} muss ein Symbol sein.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} kann nur Großbuchstaben enthalten.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} kann nur Kleinbuchstaben enthalten.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} muss vor dem ${date(args[0])} liegen.`;
  }
  return `${sentence(name)} muss in der Vergangenheit liegen.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Dieses Feld wurde falsch konfiguriert und kann nicht übermittelt werden.`;
  }
  return `${sentence(name)} muss zwischen ${args[0]} und ${args[1]} sein.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} stimmt nicht überein.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ist kein gültiges Datum im Format ${args[0]}.`;
  }
  return "Dieses Feld wurde falsch konfiguriert und kann nicht übermittelt werden.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} muss zwischen ${date(args[0])} und ${date(args[1])} liegen.`;
};
var email = "E-Mail Adresse ist ungültig.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} endet nicht mit ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} enthält einen ungültigen Wert.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = first <= second ? first : second;
  const max2 = second >= first ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} muss mindestens ein Zeichen enthalten.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} darf maximal ${max2} Zeichen enthalten.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} sollte ${max2} Zeichen lang sein.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} muss mindestens ${min2} Zeichen enthalten.`;
  }
  return `${sentence(name)} muss zwischen ${min2} und ${max2} Zeichen enthalten.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} enthält einen ungültigen Wert.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Darf maximal ${args[0]} ${name} haben.`;
  }
  return `${sentence(name)} darf maximal ${args[0]} sein.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Keine Dateiformate konfiguriert.";
  }
  return `${sentence(name)} muss vom Typ ${args[0]} sein.`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Mindestens ${args[0]} ${name} erforderlich.`;
  }
  return `${sentence(name)} muss mindestens ${args[0]} sein.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” ist kein gültiger Wert für ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} muss eine Zahl sein.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" oder ")} ist erforderlich.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} ist erforderlich.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} beginnt nicht mit ${list(args)}.`;
};
var url = function() {
  return `Bitte geben Sie eine gültige URL ein.`;
};
var invalidDate = "Das gewählte Datum ist ungültig.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var de_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, de_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=de.mjs.map